import React from 'react';
import {Box} from '@mui/material';
import ArrLinearProgressBar from '../../../components/common/arr-linear-progressbar/ArrLinearProgressBar';

const ArrLinearProgressBarDemo: React.FC = () => {
  const total = 18;
  const completed = 5;
  return (
    <Box
      p={3}
      sx={{backgroundColor: 'black', minHeight: '100vh', color: 'white'}}
    >
      <h3>Default Progress with auto-label</h3>
      <ArrLinearProgressBar completed={completed} total={total} />

      <h3>Custom Label</h3>
      <ArrLinearProgressBar
        completed={completed}
        total={total}
        label="Reviewing Documents..."
      />

      <h3>Edge Case: Zero Total</h3>
      <ArrLinearProgressBar completed={0} total={0} />
    </Box>
  );
};

export default ArrLinearProgressBarDemo;
